import { useTranslation } from 'react-i18next';
import ChevronLink from '../ChevronLink/ChevronLink';
import Paper from '../Paper/Paper';
import './Section.css';

export type SectionPropsType = {
    title?: string;
    subtitle?: string;
    children?: React.ReactNode;
    className?: string;
    contentClassName?: string;
    titleElement?: React.ReactNode | JSX.Element;
    titleElementCondition?: boolean;
    showMoreChevronLinkProps?: {
        text: string;
        link: string;
    };
    showMoreContentProps?: {
        onClick: () => void;
        condition: boolean;
    };
};

// Wrapper for individual sections that can contain title, subtitle and content.
// TODO: Naming collision with Widget/section
const Section = ({
    title,
    subtitle,
    children,
    className,
    contentClassName,
    titleElement,
    titleElementCondition = true,
    showMoreChevronLinkProps,
    showMoreContentProps
}: SectionPropsType) => {
    const { t } = useTranslation();

    return (
        <Paper className={`section ${className || ''}`}>
            {title && (
                <div className='title-container'>
                    <h3>{title}</h3>
                    {titleElement && titleElementCondition && <div className='title-element'>{titleElement}</div>}
                </div>
            )}
            {subtitle && <p className='section-subtitle'>{subtitle}</p>}
            <div className={`content ${contentClassName || ''} ${!title ? 'no-title' : ''}`}>{children}</div>
            {(showMoreContentProps?.condition || showMoreChevronLinkProps) && (
                <div className={`section-footer${showMoreContentProps?.condition ? ' show-more-visible' : ''}`}>
                    {showMoreContentProps?.condition && (
                        <ChevronLink
                            chevronDirection='left-down'
                            linkDisabled
                            text={t('show-more')}
                            onClick={showMoreContentProps.onClick}
                        />
                    )}
                    {showMoreChevronLinkProps && (
                        <ChevronLink
                            text={showMoreChevronLinkProps.text}
                            linkUrl={showMoreChevronLinkProps.link}
                            chevronDirection='right'
                            className='show-more-link'
                        />
                    )}
                </div>
            )}
        </Paper>
    );
};

export default Section;
